module.exports = __webpack_public_path__ + "static/instrumentclose-2c70e00c5d74f893087ffcdc531e07f0.jpg";